'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Truck;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Truck(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-truck', className),
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M14.8,1.75002921 C15.1333332,1.75002921 15.4166668,1.86669572 15.65,2.10002837 C15.8833332,2.33336102 16,2.61669393 16,2.95002635 L16,11.5500058 C16,11.7166722 15.9416668,11.8583383 15.825,11.9750048 C15.7083332,12.0916713 15.5666668,12.1500044 15.4,12.1500044 L14.4,12.1500044 C14.4,12.8166696 14.1666668,13.3833347 13.7,13.8500004 C13.2333332,14.316666 12.6666668,14.5499987 12,14.5499987 C11.3333332,14.5499987 10.7666668,14.316666 10.3,13.8500004 C9.83333321,13.3833347 9.6,12.8166696 9.6,12.1500044 L6.4,12.1500044 C6.4,12.8166696 6.16666679,13.3833347 5.7,13.8500004 C5.23333321,14.316666 4.66666679,14.5499987 4,14.5499987 C3.33333321,14.5499987 2.76666679,14.316666 2.3,13.8500004 C1.83333321,13.3833347 1.6,12.8166696 1.6,12.1500044 L0.6,12.1500044 C0.433333206,12.1500044 0.291666794,12.0916713 0.175,11.9750048 C0.0583332062,11.8583383 0,11.7166722 0,11.5500058 L0,11.1500068 C0,10.9833404 0.0583332062,10.8416743 0.175,10.7250078 C0.291666794,10.6083413 0.433333206,10.5500082 0.6,10.5500082 L0.8,10.5500082 L0.8,7.85001466 C0.8,7.51668225 0.916666794,7.23334934 1.15,7.00001669 L3.65,4.50002265 C3.88333321,4.26669 4.16666679,4.15002348 4.5,4.15002348 L5.6,4.15002348 L5.6,2.95002635 C5.6,2.61669393 5.71666679,2.33336102 5.95,2.10002837 C6.18333321,1.86669572 6.46666679,1.75002921 6.8,1.75002921 L14.8,1.75002921 Z M3.99999046,13.3500015 C4.33332287,13.3500015 4.61665579,13.233335 4.84998844,13.0000024 C5.08332109,12.7666697 5.1999876,12.4833368 5.1999876,12.1500044 C5.1999876,11.816672 5.08332109,11.5333391 4.84998844,11.3000064 C4.61665579,11.0666738 4.33332287,10.9500073 3.99999046,10.9500073 C3.66665805,10.9500073 3.38332514,11.0666738 3.14999249,11.3000064 C2.91665984,11.5333391 2.79999332,11.816672 2.79999332,12.1500044 C2.79999332,12.4833368 2.91665984,12.7666697 3.14999249,13.0000024 C3.38332514,13.233335 3.66665805,13.3500015 3.99999046,13.3500015 Z M5.59998665,8.15001395 L5.59998665,5.35002062 L4.49998927,5.35002062 L1.99999523,7.85001466 L1.99999523,8.15001395 L5.59998665,8.15001395 Z M11.9999714,13.3500015 C12.3333038,13.3500015 12.6166367,13.233335 12.8499694,13.0000024 C13.083302,12.7666697 13.1999685,12.4833368 13.1999685,12.1500044 C13.1999685,11.816672 13.083302,11.5333391 12.8499694,11.3000064 C12.6166367,11.0666738 12.3333038,10.9500073 11.9999714,10.9500073 C11.666639,10.9500073 11.3833061,11.0666738 11.1499734,11.3000064 C10.9166408,11.5333391 10.7999743,11.816672 10.7999743,12.1500044 C10.7999743,12.4833368 10.9166408,12.7666697 11.1499734,13.0000024 C11.3833061,13.233335 11.666639,13.3500015 11.9999714,13.3500015 Z' })
  );
}

Truck.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Truck/Truck.js
// module id = 280
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14